import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { RELATIONS_RESOURCE, CREATE_RELATION_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const CreateRelationService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_RELATION_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.relations(),
        body,
        meta: {
          callback,
          addToOtherList: {
            resource: RELATIONS_RESOURCE,
          },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createRelationFailed'),
            onSuccessMessage: t('createRelationSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateRelationService;
